import { RootState, _ } from "common";
import { createSelector } from "reselect";

const selectPromotional = (state: RootState) => state.Vocuher;

const selectLoadingVoucher = createSelector(
  selectPromotional,
  (state) => state.isLoading
);

const selectCurrentVoucher = createSelector(
  selectPromotional,
  (state) => state.selectedVoucher
);

const selectEligibleVoucherList = createSelector(
  selectPromotional,
  (state) => state.eligibleVoucherList
);

export const selectors = {
  selectLoadingVoucher,
  selectCurrentVoucher,
  selectEligibleVoucherList,
};
